export class UserStatistics {
  studentCount: number=0;
  guardianCount: number=0;
  employeeCount: number=0;
  newStudentsCount: number=0;
}
